import $ from 'jquery';

const events = $({});

export default events;
